export function minuteToTime(minute) {
    var hour = Math.floor(minute / 60);
    var min = minute % 60;
    hour = hour < 10 ? "0" + hour : hour;
    min = min < 10 ? "0" + min : min;
    return hour + ":" + min;
}

//日期格式化
export const formDate = (date = new Date(), type = 1) => {
    date = new Date(date);
    let year = date.getFullYear();
    let month =
        date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
    let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
    let houre = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
    let minutes =
        date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
    let seconds =
        date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds();
    switch (type) {
        case 1:
            return `${year}-${month}-${day}`;
        case 2:
            return `${year}-${month}-${day} ${houre}:${minutes}:${seconds}`;
        case 3:
            return `${year}年${month}月${day}日`;
    }
};

const hhmmToMinute = (hhmm, flag) => {
    try {
        if (hhmm == 'now' || hhmm == '现在') {
            if (flag) return -1 // 当前时间，分钟数设为-1
            let nowDate = new Date()
            hhmm = nowDate.getHours() + ':' + nowDate.getMinutes()
        }
        var arr = hhmm.split(":");
        return Number(arr[0]) * 60 + Number(arr[1]);
    } catch (e) {
        return 0
    }
};

const minuteToHHmm = (minute) => {
    if (minute == 'now' || minute == '现在') {
        minute = hhmmToMinute(minute)
    }
    var hour = Math.floor(minute / 60);
    var min = minute % 60;
    hour = hour < 10 ? '0' + hour : hour;
    min = min < 10 ? '0' + min : min;
    return hour + ":" + min;
};

const formDate1 = (date = new Date(), type = 1) => {
    date = new Date(date);
    console.log(date)
    let year = date.getFullYear();
    let month =
        date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
    let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
    let houre = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
    let minutes =
        date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
    let seconds =
        date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds();
    switch (type) {
        case 1:
            return `${year}-${month}-${day}`;
        case 2:
            return `${year}-${month}-${day} ${houre}:${minutes}:${seconds}`;
        case 3:
            return `${year}年${month}月${day}日`;
    }
};

export default {
    formDate1, hhmmToMinute, minuteToHHmm
}


// WEBPACK FOOTER //
// ./src/lib/utils.js